<dashboard-panel *ngIf="skin !== 'uk-steel-blue'"></dashboard-panel>
<dashboard-panel-uk *ngIf="skin === 'uk-steel-blue'"></dashboard-panel-uk>
